import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import { typography, TypographyVariant } from '../typography';

export interface HeadlineProps {
  title: string;
  variant?: TypographyVariant;
}

export const ThemeHeadline: React.FC<HeadlineProps & { className?: string }> = ({ title, className, variant }) => {
  return (
    <Header className={className}>
      <Title $variant={variant}>{title}</Title>
    </Header>
  );
};

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spacing.xs};
`;

const Title = styled.div<{ $variant?: TypographyVariant }>`
  ${props => typography(props.$variant || 'body1')};
  font-weight: 600;
  margin: 0;
  flex-grow: 1;
`;
